import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Button from '../../components/form-components/Button';
import Fields from '../../components/form-components/Fields';
import Yup from '../../validations/validationsLib';
import eyeline from "../../assets/images/eyelineicn.svg";
import eye from "../../assets/images/eyeicn.svg";
import { activateAccount } from '../../features/auth/activate-account/activateAccountSlice';
import { OK } from '../../constants/statusCode';
import { showSuccess } from '../../utils/messageHelper';

const ActivateAccountModal = ({
  isOpen,
  toggle = () => { },
}) => {

  const [togglePassword, setTogglePassword] = useState(false);
  const [toggleConfirmPassword, setToggleConfirmPassword] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const verifyActivateAccountToken = searchParams.get("activate_account");
  const dispatch = useDispatch();

  const handleUpdatePassword = async (values) => {
    let formData = values;
    formData.email_verify_token = verifyActivateAccountToken;
    delete formData.confirmPassword;
    const { payload } = await dispatch(activateAccount(formData));
    if (payload.status === OK) {
      showSuccess(payload?.data?.responseMessage);
      toggle();
    }
  };

  return (
    <div>
      <Modal
        className="add-document-popup update-password"
        show={isOpen}
        onHide={toggle}
        backdrop="static"
        keyboard={false}
        // modalTransition={{ timeout: 2000 }}
        dialogClassName="common-modal"
        centered={true}
      >
        <Modal.Header>
          <h3 className="modal-title" id="Add_OrganizationLabel">
            Activate Account
          </h3>
          {/* <Button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={toggle}
          ></Button> */}
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              password: "",
              confirmPassword: "",
            }}
            validationSchema={
              Yup.object().shape({
                password: Yup.string().matches(
                  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_])[A-Za-z\d@$!%*#?&_]{8,32}$/,
                  "Password should contains 8-32 characters. At least 1 digit, 1 special character, 1 uppercase letter & 1 lowercase letter."
                ).required("Password cannot be blank!"),
                confirmPassword: Yup.string()
                  .oneOf(
                    [Yup.ref("password"), null],
                    "Password & confirm password must be same."
                  )
                  .required("Confirm password cannot be blank!"),
              })}
            onSubmit={handleUpdatePassword}
          >
            {({
              values,
              handleChange,
              handleBlur,
              touched,
              isSubmitting,
              errors,
              handleSubmit,
            }) => (
              <Form>
                <div className="">
                  <p className='mb-3'>Please set your password to get your DocoMatic account activated.</p>
                  <div className="form-group form-grp-passsword">
                    <Fields
                      type={togglePassword ? "text" : "password"}
                      placeholder="Password"
                      touched={touched}
                      errors={errors}
                      onBlur={handleBlur}
                      name="password"
                      value={values.password}
                      className="form-control"
                      onChange={handleChange}
                    />
                    <span
                      className={`icon-${togglePassword ? "Hide" : "Hide"}`}
                      onClick={() => setTogglePassword(!togglePassword)}
                    >
                      <img
                        className="eye-icn"
                        src={togglePassword ? eye : eyeline}
                        alt="show password"
                      />
                    </span>
                  </div>
                  <div className="form-group form-grp-passsword">
                    <Fields
                      type={toggleConfirmPassword ? "text" : "password"}
                      placeholder="Confirm Password"
                      touched={touched}
                      errors={errors}
                      onBlur={handleBlur}
                      name="confirmPassword"
                      value={values.confirmPassword}
                      className="form-control"
                      onChange={handleChange}
                    />
                    <span
                      className={`icon-${toggleConfirmPassword ? "Hide" : "Hide"
                        }`}
                      onClick={() =>
                        setToggleConfirmPassword(!toggleConfirmPassword)
                      }
                    >
                      <img
                        className="eye-icn"
                        src={toggleConfirmPassword ? eye : eyeline}
                        alt="show password"
                      />
                    </span>
                  </div>
                  <div className="form-group text-end">
                    <Button
                      type="button"
                      className="btn btn-primary-md mt-1"
                      onClick={handleSubmit}
                      disabled={isSubmitting}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ActivateAccountModal;